/**
 * @flow
 */

import React, { useEffect, useState, useCallback } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { defineMessages, injectIntl } from 'react-intl';
import { Message, Icon } from 'semantic-ui-react';

const intlMessages = defineMessages({
    defaultErrorMessage: {
        id: 'pages.clients.verifyeEmailForm.error',
        defaultMessage:
            'User with required token does not exists in our database',
    },
});

export const VERIFY_EMAIL_QUERY = gql`
    mutation verifyEmailByToken($input: VerifyEmailByTokenInput!) {
        verifyEmailByToken(input: $input) {
            success
        }
    }
`;

const VerifyEmailForm = ({ token, email, intl }: any) => {
    const history = useHistory();
    const [error, setError] = useState(null);
    const [verifyEmail] = useMutation(VERIFY_EMAIL_QUERY);

    const onSubmit = useCallback(async () => {
        try {
            await verifyEmail({ variables: { input: { token, email } } });
            history.push('/salon/appointments');
        } catch (e) {
            setError(intl.formatMessage(intlMessages.defaultErrorMessage));
        }
    }, [verifyEmail, token, email, history, intl]);

    // Auto-verify once on mount.
    useEffect(() => {
        onSubmit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {error && (
                <Message error>
                    <Icon name="warning sign" />
                    {error}
                </Message>
            )}
        </div>
    );
};

export default injectIntl(VerifyEmailForm);
